import { render, staticRenderFns } from "./OlvidoContrasenia.vue?vue&type=template&id=c1d408e0&"
import script from "./OlvidoContrasenia.vue?vue&type=script&lang=js&"
export * from "./OlvidoContrasenia.vue?vue&type=script&lang=js&"
import style0 from "./OlvidoContrasenia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports